import { useEffect, useState } from "react"
import { Input, Button, Table, Select, DatePicker, Modal, Space, Form } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 }
}

type fetchParams = {
    store_id: string | undefined,
    rollOutDate: any,
    review_status: number | undefined,
    handleDate: any,
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

interface ep {
    "employee_id": string,
    "user_name": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        rollOutDate: undefined,
        review_status: undefined,
        handleDate: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    const [form] = useForm()
    const [visibled, setVisibled] = useState<boolean>(false)
    const [activeID, setActiveID] = useState<string>()

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'rollOutDate', ['roll_out_date_start', 'roll_out_date_end'])
        handleDate(params, 'handleDate', ['handle_date_start', 'handle_date_end'])

        axiosTable.get('/keeper/across_store/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 管家中心 -> 入住管理 -> 跨店转房管理 */}
        <BreadCrumb position={['管家中心', '跨店转房管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores onChange={(value: string) => {
                        handleChange(value, 'store_id')
                    }} value={fetchOtherParams.store_id} />
                </div>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["转出开始日期", "转出结束日期"]} value={fetchOtherParams.rollOutDate} onChange={(v: any) => { handleChange(v, 'rollOutDate') }} />
                <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="审核状态" value={fetchOtherParams.review_status} onChange={(v: number) => { handleChange(v, 'review_status') }}>
                    <Option value={0} key={0}>待审核</Option>
                    <Option value={1} key={1}>审核通过</Option>
                    <Option value={2} key={2}>审核不通过</Option>
                </Select>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["处理开始日期", "处理结束日期"]} value={fetchOtherParams.handleDate} onChange={(v: any) => { handleChange(v, 'handleDate') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {<Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column title="转出日期" dataIndex="roll_out_date" key="roll_out_date" />
                <Column title="转出门店" dataIndex="roll_out_store_name" key="roll_out_store_name" />
                <Column title="客户姓名" dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column title="联系电话" dataIndex="check_in_phone" key="check_in_phone" />

                <Column title="转入门店" dataIndex="shift_in_store_name" key="shift_in_store_name" />
                <Column title="备注" dataIndex="remark" key="remark" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
                <Column title="审核状态" dataIndex="review_status_desc" key="review_status_desc" />

                <Column title="操作" render={(row: any) => {
                    if (row.review_status == 0) {
                        return <Space>
                            <Button size="small" onClick={() => {
                                setActiveID(row.across_store_id)
                                setVisibled(true)
                            }}>审核</Button>
                        </Space>
                    } else {
                        return null
                    }
                }} />
            </Table>
        </div>

        <Modal title="跨店转房审批" visible={visibled} onCancel={() => { setVisibled(false) }} onOk={() => {
            baseAxiosComplete.post('/keeper/across_store/review', {
                review_status: form.getFieldValue('review_status'),
                review_refuse_reason: form.getFieldValue('review_refuse_reason'),
                across_store_id: activeID

            }).then(res => {
                if (res.status == 0) {
                    setVisibled(false)
                    fetch({ pagination: pagination, fetchOtherParams: fetchOtherParams })
                }
            })
        }}>
            <Form form={form} {...formItemLayout}>
                <Form.Item label="是否通过" name="review_status" required>
                    <Select>
                        <Option value={1} >审核通过</Option>
                        <Option value={2} >审核不通过</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="备注（不通过原因）" name="review_refuse_reason" required >
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}